
import React,{useState} from 'react';

export default function App(){
 const [form,setForm]=useState({name:'',gender:'',dob:'',mobile:'',religion:'',caste:'',location:''});
 const [msg,setMsg]=useState(false);

 const change=e=>setForm({...form,[e.target.name]:e.target.value});

 const submit=async(e)=>{
  e.preventDefault();
  if (!/^[0-9]{10}$/.test(form.mobile)) {
    alert('Please enter a valid 10-digit mobile number.');
    return;
  }

  const endpoint = 'https://bandham-gamma.vercel.app/send-email';

  try{
    const response = await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(form)});
    if(!response.ok) throw new Error(await response.text());
    setMsg(true);
    setForm({name:'',gender:'',dob:'',mobile:'',religion:'',caste:'',location:''});
  }catch(err){
    console.error(err);
    alert('Email failed to send. Check server configuration.');
  }
 };

 return (
 <div className="page">
  <div className="hero">
    <div className="hero-panel">
      <div className="slider">
        <div className="slide"><img src="/slide1.jpg" alt="Slide 1"/></div>
        <div className="slide static-slide"><img src="/slide2.jpg" alt="Slide 2"/></div>
        <div className="slide"><img src="/slide3.jpg" alt="Slide 3"/></div>
        <div className="slide"><img src="/slide4.jpg" alt="Slide 4"/></div>
        <div className="slide"><img src="/slide5.jpg" alt="Slide 5"/></div>
      </div>
    </div>

    <div className="card">
      <div className="card-header">
        <img className="card-logo" src="/logo.png" alt="Match Maker logo" />
        <p className="card-tagline"><strong>Journey of joy, begins here</strong></p>
      </div>
      <form onSubmit={submit}>
        <input name="name" placeholder="Name" value={form.name} onChange={change} required/>
        <div className="gender">
          <label><input type="radio" name="gender" value="Male" onChange={change} required/> Male</label>
          <label><input type="radio" name="gender" value="Female" onChange={change}/> Female</label>
        </div>
        <div className="two-column">
          <input type="date" name="dob" value={form.dob} onChange={change} required/>
          <input name="mobile" type="tel" placeholder="Mobile Number" pattern="[0-9]{10}" maxLength="10" value={form.mobile} onChange={change} required title="Enter exactly 10 digits"/>
        </div>
        <div className="two-column">
          <input name="religion" placeholder="Religion" value={form.religion} onChange={change}/>
          <input name="caste" placeholder="Caste" value={form.caste} onChange={change}/>
        </div>
        <input name="location" placeholder="Location" value={form.location} onChange={change} required/>
        <button type="submit">Register Free</button>
      </form>
    </div>
  </div>

  {msg && <div className="overlay"><div className="popup"><h2>Thank You!</h2><p>Thank you so much for your input and our executives will connect shortly.</p><button onClick={()=>setMsg(false)}>OK</button></div></div>}
 </div>
 );
}
